<template>
  <!-- Modal -->
  <div>
    <md-button @click="showAddActDialog = true">
      <i class="material-icons" style="font-size: 30pt;">add_circle_outline</i>
    </md-button>
    <md-dialog :md-active.sync="showAddActDialog" @md-opened="prepare" @md-closed="cleanUp" @md-clicked-outside="cancel">
      <md-dialog-content id="content">
        <form name="add_form" id="add_form">
          <div class="container-fiuld">
            <div class="row">
              <div class="col-xs-6">
                <md-field>
                  <label>標題*</label>
                  <md-input id="title" name="name" />
                </md-field>
              </div>
              <div class="col-xs-6">
                <div class="md-layout-item">
                  <md-field>
                    <label for="type">任務類型</label>
                    <md-select v-model="typeString" id="type">
                      <md-option v-for="type in types" :value="type.value" :key="type.value">{{type.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <md-field>
                  <label>簡介（選填）</label>
                  <md-textarea type="text" id="desc" name="description" rows="4"></md-textarea>
                </md-field>
              </div>
            </div>
            <div v-show="isAdvanceMode" class="row">
              <div class="col-md-12">
                <div class="form_label">Category:</div>
                <div class="row" style="padding:10px;">
                  <div class="col-md-3">
                    <input type="radio" id="pre-class" name="class_type" value="PRE-CLASS" />
                    <label for="pre-class" class="rad_label">課前</label>
                  </div>
                  <div class="col-md-3">
                    <input type="radio" id="in-class" name="class_type" value="IN-CLASS" />
                    <label for="in-class" class="rad_label">課上</label>
                  </div>
                  <div class="col-md-3">
                    <input type="radio" id="after-class" name="class_type" value="AFTER-CLASS" />
                    <label for="after-class" class="rad_label">課後</label>
                  </div>
                  <div class="col-md-3">
                    <input type="radio" id="other-class" name="class_type" value="OTHERS" checked />
                    <label for="other-class" class="rad_label">其他</label>
                  </div>
                </div>
              </div>
            </div>
            <md-tabs v-show="typeString === 'Video'" :md-active-tab="activeTab" @md-changed="changeTab">
              <md-tab id="md-tab-video-upload" md-label="上傳影片" data-value="upload">
                <md-field>
                  <label>影片</label>
                  <md-file accept="video/*" name="upload_material" />
                </md-field>
                <md-switch v-model="willPutMyResource">放至我的資源</md-switch>
                <div style="color: #777;">註: 影片大小上限為128MB</div>
              </md-tab>
              <md-tab id="md-tab-video-pool" md-label="學習資源">
                <!-- video/file filter should be added here -->
                <VideoPool v-bind:key="'md-tab-video-pool'" :folders="folders" :actions="videoActions" :typeFilter="videoTypeFilter" :pageSize="5"/>
              </md-tab>
              <md-tab id="md-tab-video-mypool" md-label="我的影片">
                <!-- video/file filter should be added here -->
                <VideoPool v-bind:key="'md-tab-video-mypool'" :folders="myfolders" :actions="videoActions" :typeFilter="videoTypeFilter" :pageSize="5" :showFilter="false"/>
              </md-tab>
            </md-tabs>
            <md-tabs v-show="typeString === 'Reading'" :md-active-tab="activeTab" @md-changed="changeTab">
              <md-tab id="md-tab-reading-upload" md-label="上傳檔案">
                <md-field>
                  <label>檔案</label>
                  <md-file accept="*" name="upload_materials[]" multiple />
                </md-field>
                <div style="color: #777;">註: 檔案大小上限為128MB</div>
                <md-switch v-model="willPutMyResource">放至我的資源</md-switch>
              </md-tab>
              <md-tab v-if="false" id="md-tab-reading-pool" md-label="學習資源">
                <!-- video/file filter should be added here -->
                <VideoPool v-bind:key="'md-tab-reading-pool'" :folders="folders" :actions="fileActions" :typeFilter="nonVideoTypeFilter" :pageSize="5" :showFilter="false" emptyString="沒有檔案"/>
              </md-tab>
              <md-tab id="md-tab-reading-mypool" md-label="我的檔案">
                <!-- video/file filter should be added here -->
                <VideoPool v-bind:key="'md-tab-reading-mypool'" :folders="myfolders" :actions="fileActions" :typeFilter="nonVideoTypeFilter" :pageSize="5" :showFilter="false" emptyString="沒有檔案"/>
              </md-tab>
            </md-tabs>
            <div v-show="typeString === 'uReply'" style="color: #777;">
              <div>註1: uReply支援中文問題，但暫時只有英文界面。</div>
              <div>註2: 新增後必須進入任務設置uReply問題。</div>
              <div>註3: 問答環節會在確認問題後一分鐘後開放。</div>
              <div>註4: 問答環節終止後學生將無法開啟。</div>
            </div>
            <div class="row">
              <div class="col-xs-12" style="text-align: right;">
                <el-button type="primary" @click="addMission">新增任務</el-button>
              </div>
            </div>
          </div>
        </form>
        <div style="position: absolute; top: 0; right: 0; cursor: pointer; width: 36px; height: 36px;" @click="showAddActDialog = false">
          <eva-icon name="close-outline" width="100%" height="100%"></eva-icon>
        </div>
      </md-dialog-content>
    </md-dialog>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<style scoped>
  #content {
    min-width: 50% !important;
    padding: 30px !important;
  }
</style>
<script type="text/javascript">
import VideoPool from '@/components/Video/VideoPool.vue'
import Loading from '@/components/Utility/Loading.vue'
import { EvaIcon } from 'vue-eva-icons'

// import EditMaterialModal from '@/components/Weeks/EditMaterialModal'
import $ from 'jquery'
export default {
  components: {
    Loading,
    VideoPool,
    [EvaIcon.name]: EvaIcon
    // EditMaterialModal
  },
  props: {
    preShowAddActDialog: {
      type: Boolean,
      default: false
    },
    preVideoChoose: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      courseId: this.$parent.courseId,
      weekId: this.$parent.id,
      files: [],

      showAddActDialog: this.preShowAddActDialog,
      types: [{
        value: 'Video',
        name: '影片'
      }, {
        value: 'Reading',
        name: '分享檔案'
      }, {
        value: 'uReply',
        name: 'uReply 練習'
      }],
      typeString: 'Video',
      videoActions: [{
        fn: this.addVideo,
        name: '增加此影片'
      }],
      // fileActions: [],
      fileActions: [{
        fn: this.addVideo,
        name: '增加此檔案'
      }],
      uploadFile: null,
      videoChoose: this.preVideoChoose,
      activeTab: `md-tab-video-${!this.videoChoose || this.videoChoose === -1 ? 'upload' : 'pool'}`,
      folders: [],
      myfolders: [],
      willPutMyResource: true,
      isLoading: false,
      videoTypeFilter: file => file.info.type === 'video',
      nonVideoTypeFilter: file => file.info.type !== 'video'
    }
  },
  methods: {
    addVideo: function (file) {
      this.videoChoose = this.videoChoose !== file.info.id ? file.info.id : -1
    },
    addMission: async function (event) {
      if (!confirm('確定提交？')) {
        return
      }
      let fd = new FormData(document.getElementById('add_form'))
      fd.append('type', this.typeString)
      if (this.typeString === 'Video' || this.typeString === 'Reading') {
        fd.append('file_resources', this.videoChoose)
        fd.append('isUploadFile', this.activeTab.indexOf('upload') > -1)
        fd.append('willPutMyResource', this.willPutMyResource)
      }
      try {
        this.isLoading = true
        let id = await this.$store.dispatch('request', {
          method: 'post',
          route: `courses/${this.courseId}/weeks/${this.weekId}/activities`,
          data: fd
        })
        alert('成功')
        this.$parent.addActivity({
          id: id,
          name: fd.get('name'),
          description: fd.get('description'),
          category: fd.get('class_type'),
          completedPercent: 0,
          type: this.typeString,
          permissions: {
            can_access: true
          }
        })
        this.showAddActDialog = false
      } catch (err) {
        console.error(err)
        alert('失敗')
      }
      this.isLoading = false
    },
    prepare: function () {
      $('body').attr('have_change', 'false')
      $('#add_form').find('input, textarea').on('keypress change', function (e) {
        $('body').attr('have_change', 'true')
      })
      $('#add_form').find('select').on('change', function (e) {
        $('body').attr('have_change', 'true')
      })
    },
    cleanUp: function () {
      this.typeString = 'Video'
    },
    cancel: function () {
      // let hvInput = Array.from(this.formData.values()).some(v => v !== null && v.length !== 0)
      if ($('body').attr('have_change') === 'true' && !confirm('放棄?')) {
        this.showAddActDialog = true
      }
    },
    changeTab: function (tabId) {
      console.log(tabId)
      this.activeTab = tabId
    },
    fetchFiles: function () {
      this.$store.dispatch('request', {
        route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}/files`
      }).then(files => {
        this.files = files
      })
    }
  },
  computed: {
    isAdvanceMode: function () {
      return this.$parent.isAdvanceMode
    },
    formData: () => {
      return new FormData(document.getElementById('add_form'))
    }
  },
  watch: {
    typeString: function (type) {
      $('body').attr('have_change', 'true')
      this.activeTab = `md-tab-${this.typeString.toLowerCase()}-upload`
      $(`#md-tab-${this.typeString.toLowerCase()}-upload`).parent().parent().css('height', '160px')
      $(`#md-tab-${this.typeString.toLowerCase()}-upload`).height('160px')
      // console.log(Array.from($(`#md-tab-${this.typeString.toLowerCase()}-upload>*`)).map(v => $(v).height()))
      // console.log(Array.from($(`#md-tab-${this.typeString.toLowerCase()}-upload>*`)).map(v => $(v)))
      // console.log(Array.from($(`#md-tab-${this.typeString.toLowerCase()}-upload>*`)).map(v => $(v).outerHeight()))
    },
    videoChoose: function (id, oldId) {
      if (id > 0) {
        $(`.videocell#${id}`).css({
          border: 'lightblue solid 3px'
        })
      }
      $(`.videocell#${oldId}`).css({
        border: ''
      })
    },
    showAddActDialog: function (show) {
      if (show) {
        console.log('fetching public resource')
        this.$store.dispatch('request', {
          route: 'resources'
        }).then(result => {
          this.folders = result
        })
        console.log('fetching private resource')
        this.$store.dispatch('request', {
          route: 'resources/self'
        }).then(result => {
          this.myfolders = result.sub_folders
        })
      }
    }
  }
}

</script>
